import { Tooltip } from "@ameelio/ui";
import Lock from "@mui/icons-material/Lock";
import { CallFeature } from "../../api/graphql";
import { callFeaturesDescription } from "../../lib/securityFeaturesUtils.ts";
import CallWidget from "./CallWidget";

export default function CallConfidentialWidget({
  features,
}: {
  features: CallFeature[];
}) {
  return (
    <CallWidget>
      <Tooltip title={callFeaturesDescription(features)}>
        <Lock sx={{ height: 16 }} />
      </Tooltip>
    </CallWidget>
  );
}
